import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbTack } from '@fortawesome/free-solid-svg-icons'
import { getCountryFlag } from '../../../utils/personUtils'
import clsx from 'clsx'

interface Props {
    location?: string
    showLabel?: boolean
    className?: string
}

export default function GetCountryFlag({
    location = '',
    showLabel = true,
    className,
}: Props): React.JSX.Element {
    const country = location.split(',').pop()?.trim() ?? ''
    const flag = getCountryFlag(country)

    return (
        <div className={clsx('flex items-center gap-2', className)}>
            {/* Fixed-size container ensures perfect alignment */}
            <span className="w-[20px] h-[20px] flex justify-center items-center">
                {flag ? (
                    <span className="text-sm leading-none">{flag}</span>
                ) : (
                    <FontAwesomeIcon
                        icon={faThumbTack}
                        className="text-gray-600 text-sm"
                    />
                )}
            </span>

            {showLabel && (
                <span className="line-clamp-1 leading-tight">{location}</span>
            )}
        </div>
    )
}
